document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.header');
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 10);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    const glow = document.createElement('div');
    glow.className = 'werks-cursor-glow';
    document.body.appendChild(glow);
    let x = -999, y = -999, tx = -999, ty = -999;
    const move = (event) => {
      tx = event.clientX;
      ty = event.clientY;
      document.body.classList.add('werks-cursor-active');
    };
    const leave = () => document.body.classList.remove('werks-cursor-active');
    const tick = () => {
      x += (tx - x) * 0.18;
      y += (ty - y) * 0.18;
      glow.style.setProperty('--werks-mouse-x', x + 'px');
      glow.style.setProperty('--werks-mouse-y', y + 'px');
      requestAnimationFrame(tick);
    };
    window.addEventListener('mousemove', move, { passive: true });
    document.addEventListener('mouseleave', leave);
    tick();
  }
});
